import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import React from "react";
import "./noYesRadioGroup.scss";

interface NoYesRadioGroupProps {
  name?: string;
  value: boolean;
  onChange: (newValue: boolean) => void;
}

export default function NoYesRadioGroup(props: NoYesRadioGroupProps) {
  const [value, setValue] = React.useState(props.value);

  function onChange(event: React.ChangeEvent<unknown>) {
    const groupValue = (event.target as HTMLInputElement).value;
    const newValue = groupValue === "true";

    setValue(newValue);

    if (props.onChange) {
      props.onChange(newValue);
    }
  }

  return (
    <RadioGroup name={props.name} value={value.toString()} onChange={onChange} className="no-yes-radio">
      <FormControlLabel value="false" control={<Radio />} label="NIE" />
      <FormControlLabel value="true" control={<Radio />} label="TAK" />
    </RadioGroup>
  );
}
